export default "__VITE_ASSET__434fac2c__"